import React from 'react';
import styles from './listView.module.scss';

export const ListViewFooter = ({ resultCount, paginationData, requestReload, summary }) => {
    const updatePage = (newPage)=>{
        if(paginationData){
            paginationData.setPaginationData(prev => {
                prev.currentPageNumber = newPage;
                return prev;
            })
        }
        
        requestReload();
    }
    const prevPage = () => {
        if(paginationData?.data.previousPageAvailable ){
            updatePage(paginationData.data.currentPageNumber-1);
        }
    }
    const nextPage = () => {
        if(paginationData?.data.nextPageAvailable ){
            updatePage(paginationData.data.currentPageNumber+1);
        }
    }
    const totalElements = paginationData?.data?.totalNumberOfElements;
    let resultLabel;
    if(typeof totalElements === 'number' && (paginationData?.data?.nextPageAvailable || paginationData?.data?.previousPageAvailable)){
        if(totalElements === 0 || resultCount === 0){
            resultLabel = `0 of ${totalElements}`;
        }else{
            const currentPage = paginationData.data.currentPageNumber || 0;
            let pageSize;
            if(paginationData.data.pageSize){
                pageSize = paginationData.data.pageSize;
            }else if(paginationData.data.nextPageAvailable){
                pageSize = resultCount;
            }else if(currentPage > 0){
                pageSize = (totalElements - resultCount) / currentPage;
            }else{
                pageSize = resultCount;
            }
            const start = currentPage * pageSize + 1;
            const end = Math.min(start + resultCount - 1, totalElements);
            resultLabel = `${start}-${end} of ${totalElements}`;
        }
    }else{
        resultLabel = `${resultCount} results`;
    }
    return (
        <div className={styles.footerWrapper}>
            <div className={styles.footerResultCount}>
                {resultLabel}
                {summary ? <span className={styles.footerSummary}> · {summary}</span> : null}
            </div>
            <div className={styles.footerPagingButtons}>
                {paginationData && (
                    <>
                        <div
                            className={`${styles.footerButton} ${paginationData.data.previousPageAvailable ? styles.active : ''}`}
                            onClick={prevPage}
                        >
                            Previous
                        </div>
                        <div
                            className={`${styles.footerButton} ${paginationData.data.nextPageAvailable ? styles.active : ''}`}
                            onClick={nextPage}
                        >
                            Next
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};